import React, { useRef, useEffect } from "react";
import "./shoppingList.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMultiply } from "@fortawesome/free-solid-svg-icons";
import ShoppedItem from "./components/ShoppedItem";
import { CSSTransition } from "react-transition-group";
import "animate.css";

import { Link } from "react-router-dom";

import { useOrder } from "../../../contexts/OrderContext";

import { useShipping } from "../../../contexts/ShippingContext";

export default function ShoppingList(props) {
  useEffect(() => {
    if (props.open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [props.open]);

  const listRef = useRef(null);
  const backgroundRef = useRef(null);

  const { shoppingList, getAllPrices, dropZeros, status } = useOrder();
  const { openPaymentWindow, cancelOrder } = useShipping();

  const { price, discounts, priceAfterDiscounts } = getAllPrices();

  const items = shoppingList.map((val) => (
    <ShoppedItem key={val.ProductID} data={val} />
  ));

  return (
    <>
      <CSSTransition
        nodeRef={backgroundRef}
        in={props.open}
        timeout={300}
        unmountOnExit
        classNames="popup-background"
      >
        <div className="popup-background" ref={backgroundRef}></div>
      </CSSTransition>
      <CSSTransition
        nodeRef={listRef}
        in={props.open}
        timeout={500}
        classNames="popup"
        unmountOnExit
      >
        <div className="shopping-list-popup" ref={listRef}>
          <div className="close-button" onClick={() => props.toggle(false)}>
            <FontAwesomeIcon icon={faMultiply} />
          </div>
          <div className="shopping-list-container">
            {shoppingList.length !== 0 ? (
              <>
                <div className="upper-title">
                  <span className="upper-title-text">سفارش های شما</span>
                </div>

                <div className="shopped-items custom-scroll">{items}</div>
                <div className="shopping-list-price-container">
                  <div className="shopping-list-price-item">
                    <span className="shopping-list-price-title">
                      مجموع بدون تخفیف :
                    </span>
                    <span className="shopping-list-price">
                      <span className="shopping-list-price-amount">
                        {dropZeros(price)}
                      </span>
                      هزار تومان
                    </span>
                  </div>
                  <div className="shopping-list-price-item">
                    <span className="shopping-list-price-title">
                      تخفیف برای شما :
                    </span>
                    <span className="shopping-list-price">
                      <span className="shopping-list-price-amount">
                        {dropZeros(discounts)}
                      </span>
                      هزار تومان
                    </span>
                  </div>
                  <div className="shopping-list-price-item highlighted">
                    <span className="final-price">مجموع خرید شما :</span>
                    <span className="shopping-list-price">
                      <span className="shopping-list-price-amount">
                        {dropZeros(priceAfterDiscounts)}
                      </span>
                      هزار تومان
                    </span>
                  </div>
                </div>
                <div className="shopping-list-buttons">
                  {status < 3 || status === 7 ? (
                    <Link
                      to="/shipping/type"
                      className="list-button list-submit-button"
                      onClick={() => props.toggle(false)}
                    >
                      نهایی کردن سفارش
                    </Link>
                  ) : status === 3 ? (
                    <>
                      <div
                        className="list-button list-submit-button"
                        onClick={() => {
                          props.toggle(false);
                          openPaymentWindow();
                        }}
                      >
                        پرداخت هزینه سفارش
                      </div>
                      <div
                        className="list-button list-cancel-button"
                        onClick={() => {
                          props.toggle(false);
                          cancelOrder();
                        }}
                      >
                        لغو سفارش
                      </div>
                    </>
                  ) : status > 3 ? (
                    <Link
                      to="/order-result/success"
                      className="list-button list-submit-button"
                      onClick={() => props.toggle(false)}
                    >
                      مشاهده نتیجه سفارش
                    </Link>
                  ) : null}
                </div>
              </>
            ) : (
              <h2 className="empty-shopping-list">سبد خرید شما خالی است</h2>
            )}
          </div>
        </div>
      </CSSTransition>
    </>
  );
}
